import Postel from '@/assets/companies/postel/sidebar-logo.svg?react';
import { ExternalDesignCompany } from '@/providers';
import { ReactNode } from 'react';

export const EXTERNAL_SIDEBAR_LOGOS: Record<ExternalDesignCompany, ReactNode> = {
  postel: <Postel />,
};
